import { render, staticRenderFns } from "./ClicksOverTime.vue?vue&type=template&id=56d67348&"
import script from "./ClicksOverTime.vue?vue&type=script&lang=js&"
export * from "./ClicksOverTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports